import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@/fontawesome';
import type { ChatMessage } from '@/models/chat-message';

interface SystemQueryResponseMessageProps {
  message: ChatMessage;
}

export default function SystemQueryResponseMessage({ message }: SystemQueryResponseMessageProps) {
  return (
    <div className="my-3">
      <div className="bg-green-50 dark:bg-green-900/30 rounded-lg p-3 w-full border border-green-200 dark:border-green-800">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <FontAwesomeIcon icon={faCheckCircle} className="w-4 h-4 text-green-600 dark:text-green-400" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-medium text-green-800 dark:text-green-200 mb-1">
              System Query Response (Titel-Generierung)
            </div>
            {message.content && (
              <div className="bg-green-100 dark:bg-green-900/50 rounded p-2 max-h-20 overflow-auto w-full">
                <div className="text-sm text-green-700 dark:text-green-300 whitespace-pre-wrap">
                  {message.content}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}